import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  use,
  useRef,
} from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import * as moment from "moment";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";
import { Tooltip } from "@mui/material";
//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  getCustomerOrders as onGetCustomerOrders,
  getSupplierOrderById as onGetSupplierOrderById,
  cancelCustomerOrder as onCancelCustomerOrder,
  purchaseOrder as onPurchaseOrder,
  orderShipped as onOrderShipped,
  updateOrder as onUpdateOrder,
  getProductById as onGetProductById,
} from "../../slices/thunks";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr";
import { createSelector } from "reselect";
import OrderDetail from "./OrderDetail";
import Loader from "../../Components/Common/Loader";
import CancelModal from "./CancelModal";
import { orderStatus } from "../../Components/constants/layout";
import SupplierOrderDetail from "../Orders/OrderDetail";
import SalesChannels from "../../Components/Common/SalesChannels";
import DebouncedInput from "../../Components/Common/DebouncedInput";
import ProductDetail from "../Products/ProductDetail";

const CustomerOrders = () => {
  const [firstLoad, setFirstLoad] = useState(true);
  const [modal, setModal] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [showProductDetail, setShowProductDetail] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("all");

  const dateFrom = useRef(null);
  const dateTo = useRef(null);

  const [selectedSupplierOrder, setSelectedSupplierOrder] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [movOrders, setMovOrders] = useState([]);

  const dispatch = useDispatch();

  const selectOrderData = createSelector(
    (state) => state.Orders,
    (customerOrders) => customerOrders.customerOrders,
    (order) => order.order,
    (pagination) => pagination,
    (loading) => loading
  );
  // Inside your component
  const { customerOrders, order, pagination, loading } =
    useSelector(selectOrderData);

  const selectProductData = createSelector(
    (state) => state.Products,
    (product) => product
  );
  // Inside your component
  const { product } = useSelector(selectProductData);

  const [orderList, setOrderList] = useState([]);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [searchText, setSearchText] = useState(null);

  useEffect(() => {
    if (order && !firstLoad) {
      setShowOrderDetail(true);
    }
  }, [order]);

  useEffect(() => {
    customerOrders && setOrderList(customerOrders);
    setIsLoading(false);
    setFirstLoad(false);
  }, [customerOrders]);

  useEffect(() => {
    switch (selectedPeriod) {
      case "7 days":
        const date = new Date();
        const sevenDaysAgo = new Date(date);
        sevenDaysAgo.setDate(date.getDate() - 7);
        dateFrom.current = sevenDaysAgo;
        dateTo.current = new Date();
        break;
      case "30 days":
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(new Date().getDate() - 30);
        dateFrom.current = thirtyDaysAgo;
        dateTo.current = new Date();
        break;
      case "all":
        dateFrom.current = null;
        dateTo.current = null;
        break;
      case "custom":
        dateFrom.current = null;
        dateTo.current = null;
        break;
      default:
        dateFrom.current = null;
        dateTo.current = null;
        break;
    }
    getOrders(null, pagination?.pageSize, activeTab);
  }, [selectedPeriod]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setIsLoading(true);
      setActiveTab(tab);
      //let filteredOrders = orders;
      const data = {
        page: 0,
        total_rows: pagination?.pageSize,
        searchText: searchText,
        sort_by: "ord_id",
        status: null,
        dateFrom:
          dateFrom.current != null
            ? moment(dateFrom.current).format("YYYY-MM-DD")
            : null,
        dateTo:
          dateTo.current != null
            ? moment(dateTo.current).format("YYYY-MM-DD")
            : null,
      };

      switch (type) {
        case "all":
          data.status = null;
          break;
        case "Ordered":
          data.status = 4;
          break;
        case "Pending":
          data.status = 0;
          break;
        case "Cancelled":
          data.status = 5;
          break;
        default:
          data.status = null;
          break;
      }
      dispatch(onGetCustomerOrders(data));
    }
  };

  const getOrders = (page, pageSize) => {
    if (!firstLoad) {
      setIsLoading(true);
      const data = {
        page: page ? page : 0,
        total_rows: pageSize
          ? pageSize
          : pagination
          ? pagination?.pageSize
          : 50,
        searchText: searchText,
        sort_by: "ord_id",
        status: null,
        dateFrom:
          dateFrom.current != null
            ? moment(dateFrom.current).format("YYYY-MM-DD")
            : null,
        dateTo:
          dateTo.current != null
            ? moment(dateTo.current).format("YYYY-MM-DD")
            : null,
      };
      dispatch(onGetCustomerOrders(data));
    }
  };

  useEffect(() => {
    if (searchText != null) getOrders();
  }, [searchText]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      // setOrder(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleOrderClicks = () => {
    // setOrder("");
    //setIsEdit(false);
    toggle();
  };

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setModal(true);
  };

  const getSupplierOrderById = (order) => {
    dispatch(onGetSupplierOrderById(order.ord_suo_id));
  };
  /*
  useEffect(() => {
    selectedOrder && setModal(true);
  }, [selectedOrder]);
*/
  // Node API
  // useEffect(() => {
  //   if (isOrderCreated) {
  //     setOrder(null);
  //     dispatch(onGetOrders());
  //   }
  // }, [
  //   dispatch,
  //   isOrderCreated,
  // ]);

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".orderCheckBox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteMultiple = () => {
    const checkall = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element) => {
      // dispatch(onDeleteOrder(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".orderCheckBox:checked");
    ele.length > 0
      ? setIsMultiDeleteButton(true)
      : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  const onClickPlaceOrder = (order) => {
    {
      order.statusText === "MOV Met"
        ? setMovOrders(
            orderList.filter(
              (o) => o.suoSupId == order.suoSupId && o.statusText === "MOV Met"
            )
          )
        : purchaseOrder([order.suoId]);
    }
  };

  const purchaseOrder = useCallback((orderIds) => {
    const data = {
      suo_id: orderIds,
    };
    dispatch(onPurchaseOrder(data));
  }, []);

  const onClickCancelSupplierOrder = (order) => {
    setShowCancelOrder(true);
    setSelectedOrder(order);
  };

  const shipToWarehouse = (orders) => {
    const data = {
      suo_id: orders.suoId,
    };
    dispatch(onOrderShipped(data));
  };

  const onClickCancelOrder = (order) => {
    setSelectedOrder(order);
    setShowCancelOrder(true);
  };

  const cancelOrder = (orderId, reason, otherReason, message, outOfStock) => {
    const data = {
      ord_id: orderId,
      cancellation_reason: reason,
      cancellation_message: message,
      cancellation_reason_text: otherReason,
      set_out_of_stock: outOfStock,
    };
    dispatch(onCancelCustomerOrder(data));
    setShowCancelOrder(false);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        header: "Sup Order #",
        accessorKey: "ord_suo_id",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <div style={{ textAlign: "center" }}>
              <Link
                to="#"
                onClick={() => getSupplierOrderById(cell.row.original)}
                className="text-primary fw-semibold"
              >
                {cell.getValue()}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Order #",
        accessorKey: "ord_id",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <div style={{ textAlign: "center" }}>
              <Link
                to="#"
                onClick={() => handleOrderClick(cell.row.original)}
                className="text-primary fw-semibold"
              >
                {cell.getValue()}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Cartzy #",
        accessorKey: "ord_bc10_order_id",
        enableColumnFilter: false,
        cell: (cell) => {
          return cell.getValue() == 0 ? "N/A" : cell.getValue();
        },
      },
      {
        header: "Product",
        accessorKey: "productName",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              <Link
                onClick={() => {
                  const data = {
                    pro_id: cell.row.original.ord_pro_id,
                  };
                  dispatch(onGetProductById(data));
                  setShowProductDetail(true);
                }}
              >
                {" "}
                {cell.getValue()}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Customer",
        accessorKey: "userName",
        enableColumnFilter: false,
      },
      {
        header: "Customer Email",
        accessorKey: "userEmail",
        enableColumnFilter: false,
      },
      {
        header: "Supplier",
        accessorKey: "supplierName",
        enableColumnFilter: false,
      },

      {
        header: "Ordered QTY",
        accessorKey: "ord_quantity",
        enableColumnFilter: false,
      },
      {
        header: "Total Amount",
        accessorKey: "ord_totalPrice",
        enableColumnFilter: false,
        cell: (cell) => (
          <div style={{ textAlign: "center" }}>
            <span className="fw-semibold">
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(cell.getValue())}
            </span>
          </div>
        ),
      },
      {
        header: "Date",
        accessorKey: "ord_dateCreated",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {moment(cell.getValue()).format("MM/DD/YYYY")}
            <br />
            <small className="text-muted">
              {moment(cell.getValue()).format("hh:mm A")}
            </small>
          </>
        ),
      },
      {
        header: "Sales channel",
        accessorKey: "pro_salesChannel",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <div style={{ textAlign: "center" }}>
              <SalesChannels channel={cell.getValue()} />
            </div>
          );
        },
      },
      {
        header: "Status",
        accessorKey: "ord_status",
        enableColumnFilter: false,
        cell: (cell) => {
          if (cell.row.original.ord_cancellationReason)
            return (
              <span
                style={{ width: "100px" }}
                className="badge text-uppercase text-dark bg-danger "
              >
                Cancelled
              </span>
            );

          switch (cell.getValue()) {
            case orderStatus.STATUS_ACTIVE:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-warning"
                >
                  Pending
                </span>
              );
            case orderStatus.STATUS_ORDERED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-success"
                >
                  Ordered
                </span>
              );
            case orderStatus.STATUS_CANCELLED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-danger "
                >
                  Cancelled
                </span>
              );
            case orderStatus.STATUS_SHIPPED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-success"
                >
                  SHIPPED
                </span>
              );
            case orderStatus.STATUS_EXPIRED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-danger"
                >
                  Expired
                </span>
              );
            case orderStatus.STATUS_MOQNOTMET:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-warning"
                >
                  MOQ Not Met
                </span>
              );
            case orderStatus.STATUS_MOVNOTMET:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-warning"
                >
                  MOV Not Met
                </span>
              );
            case orderStatus.STATUS_MOQ_MET:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-success"
                >
                  MOQ Met
                </span>
              );
            case orderStatus.STATUS_MOV_MET:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-success"
                >
                  MOV Met
                </span>
              );
            case 12:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase text-dark bg-danger"
                >
                  Payment failed
                </span>
              );
            default:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-uppercase bg-warning text-dark"
                >
                  Unknown
                </span>
              );
          }
        },
      },
      {
        header: "Action",
        cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
                <Link
                  className="text-primary d-inline-block"
                  onClick={() => handleOrderClick(cellProps.row.original)}
                >
                  <i className="ri-eye-fill fs-16"></i>
                </Link>
              </li>
              {cellProps?.row.original.ord_status === 0 && (
                <li className="list-inline-item">
                  <Tooltip title="Cancel Order">
                    <button
                      className="text-danger border-0 bg-transparent p-0"
                      onClick={() =>
                        onClickCancelOrder(cellProps?.row.original)
                      }
                    >
                      <i className="ri-close-circle-fill fs-16"></i>
                    </button>
                  </Tooltip>
                </li>
              )}
            </ul>
          );
        },
      },
    ],
    [handleOrderClick, checkedAll]
  );

  const defaultdate = () => {
    let d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    let h = d.getHours() % 12 || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return (
      d.getDate() +
      " " +
      months[d.getMonth()] +
      ", " +
      d.getFullYear() +
      ", " +
      h +
      ":" +
      d.getMinutes() +
      " " +
      ampm
    ).toString();
  };

  const [date, setDate] = useState(defaultdate());

  const [isExportCSV, setIsExportCSV] = useState(false);

  document.title = "Orders | Buyers Club";
  return (
    <div className="page-content">
      <ProductDetail
        product={product}
        show={showProductDetail}
        onClose={() => setShowProductDetail(false)}
      />
      <OrderDetail
        show={modal}
        onCloseClick={() => setModal(false)}
        orders={selectedOrder}
        onSendClick={(orders) => console.log(orders)}
        onCancelClick={(order) => onClickCancelOrder(order)}
        onRefoundClick={(order, quantity) => {
          console.log(order);
          const data = {
            order: {
              ord_id: order.ord_id,
              ord_user_id: order.ord_user_id,
              ord_suo_id: order.ord_suo_id,
              ord_pro_id: order.ord_pro_id,
              ord_sup_id: order.ord_sup_id,
              ord_quantity: quantity,
              ord_totalPrice: order.ord_totalPrice,
              ord_dateCreated: order.ord_dateCreated,
              ord_datePurchaseOrder: order.ord_datePurchaseOrder,
              ord_status: order.ord_status,
            },
            update_moq: false,
          };
          dispatch(onUpdateOrder(data));
        }}
      />
      <SupplierOrderDetail
        show={showOrderDetail}
        onCloseClick={() => setShowOrderDetail(false)}
        orders={order}
        onCancelClick={(order) => onClickCancelOrder(order)}
        onSendClick={(orders) => onClickPlaceOrder(orders)}
        onShipToWarehouseClick={(orders) => shipToWarehouse(orders)}
      />
      <CancelModal
        show={showCancelOrder}
        onCancelClick={(orderId, reason, otherReason, message, outOfStock) =>
          cancelOrder(orderId, reason, otherReason, message, outOfStock)
        }
        onCloseClick={() => setShowCancelOrder(false)}
        order={selectedOrder}
      />
      <Container fluid>
        <BreadCrumb title="Customer Orders" pageTitle="Orders" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0 align-items-center d-flex">
                <h5 className="card-title mb-0 flex-grow-1">Order History</h5>
                <div className="d-flex gap-1">
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "all" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("all");
                    }}
                  >
                    ALL
                  </button>
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "7 days" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("7 days");
                    }}
                  >
                    7 Days
                  </button>
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "30 days" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("30 days");
                    }}
                  >
                    30 Days
                  </button>
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "custom" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("custom");
                    }}
                  >
                    Custom
                  </button>
                  {selectedPeriod === "custom" && (
                    <div className="d-flex align-items-center gap-2 mt-2">
                      <Flatpickr
                        className="form-control"
                        id="datepicker-publish-input"
                        placeholder="Select a date from"
                        onChange={(selectedDates, dateStr, instance) => {
                          dateFrom.current = selectedDates[0];
                          getOrders(null, pagination?.pageSize, activeTab);
                        }}
                        options={{
                          maxDate: dateTo.current,
                          mode: "single",
                          dateFormat: "m-d-Y",
                        }}
                      />
                      <span>to</span>
                      <Flatpickr
                        className="form-control"
                        id="datepicker-publish-input"
                        placeholder="Select a date to"
                        onChange={(selectedDates, dateStr, instance) => {
                          dateTo.current = selectedDates[0];
                          getOrders(null, pagination?.pageSize, activeTab);
                        }}
                        options={{
                          mode: "single",
                          minDate: dateFrom.current,
                          dateFormat: "m-d-Y",
                        }}
                      />
                    </div>
                  )}
                </div>

                <div className="col-sm-auto">
                  <div className="d-flex gap-1 flex-wrap">
                    {isMultiDeleteButton && (
                      <button
                        className="btn btn-soft-danger"
                        onClick={() => setDeleteModalMulti(true)}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    )}
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0">
                <div>
                  <div className="card-header border-0">
                    <div className="row align-items-center">
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              {
                                active: activeTab === "1",
                              },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "all");
                            }}
                            href="#"
                          >
                            <i className="ri-store-2-fill me-1 align-bottom"></i>{" "}
                            All Orders
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.total}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "Ordered");
                            }}
                            href="#"
                          >
                            Ordered
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalOrdered}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "Pending");
                            }}
                            href="#"
                          >
                            Pending
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalPendingOrders}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "4" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("4", "Cancelled");
                            }}
                            href="#"
                          >
                            Cancelled
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalCancelled}
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </div>
                  <Row className="mb-3">
                    <CardBody className="border border-dashed border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <DebouncedInput
                                value={searchText ?? ""}
                                onChange={(value) => setSearchText(value)}
                                placeholder="Search orders"
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="card-body pt-0">
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={orderList || []}
                        customPageSize={50}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light text-dark text-uppercase"
                        handleOrderClick={handleOrderClicks}
                        SearchPlaceholder="Search orders..."
                        pagination={pagination}
                        manualPagination={true}
                        onPreviousPage={() => {
                          getOrders(pagination.currentPage - 1);
                        }}
                        onNextPage={() => {
                          getOrders(pagination.currentPage + 1);
                        }}
                        onGetPage={(page, pageSize) => {
                          getOrders(page, pageSize);
                        }}
                      />
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CustomerOrders;
